import React from 'react'
// import PropTypes from 'prop-types'
import FilterDataGrid from '../components/FilterDataGrid'



function Home(props) {
	return (
		<div>
			<FilterDataGrid/>
		</div>
	)
}



export default Home

